import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const EmbeddedProfileLightSchema = z.object({
  id: z
    .string()
    .uuid()
    .nullable()
    .openapi({ description: 'User/Profile ID', example: '1c5e0e34-ccff-42b4-956b-6591e19293d6' }),
  name: z.string().nullable().openapi({ description: 'Persons name', example: 'Timely/app' }),
  avatar_url: z.string().nullable().openapi({ description: 'Avatar URL', example: 'https://...' }),
});
